import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=b9a4d74a&scoped=true&"
import script from "./ToTopButton.vue?vue&type=script&lang=js&"
export * from "./ToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ToTopButton.vue?vue&type=style&index=0&id=b9a4d74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a4d74a",
  null
  
)

export default component.exports